import script from "./CDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./CDrawer.vue?vue&type=style&index=0&id=3ede159c&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ede159c"]])

export default __exports__